<template>
  <div class="league-notice" role="status">
    <p class="league-notice-title">
      {{ t('rank.cosmeticsUnlocked', { league: t(`rank.leagues.${league}`) }) }}
    </p>
    <div class="league-notice-row">
      <img class="league-notice-sleeve" :src="sleeveSrc" alt="" />
      <AvatarView
        :config="{ cardId: player.avatar.cardId, frameId: set.frameId }"
        :size="64"
      />
      <img class="league-notice-mat" :src="matSrc" alt="" />
    </div>
    <p class="league-notice-hint">{{ t('rank.cosmeticsWhere') }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { LEAGUE_COSMETICS, gamematById, type LeagueId } from '@shared/index'
import { sleeveUrl } from '../game/sleeves'
import { useI18n } from '../i18n/t'
import { usePlayerStore } from '../stores/player'
import AvatarView from './AvatarView.vue'

const props = defineProps<{ league: LeagueId }>()

const { t } = useI18n()
const player = usePlayerStore()
const set = computed(() => LEAGUE_COSMETICS[props.league])
const sleeveSrc = computed(() => sleeveUrl(set.value.sleeveId))
const matSrc = computed(() => gamematById(set.value.matId)?.src ?? '')
</script>

<style scoped>
.league-notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: -8px 0 24px;
  animation: noticeRise var(--md-motion-medium, 300ms)
    var(--md-motion-emphasized, cubic-bezier(0.05, 0.7, 0.1, 1));
}

.league-notice-title {
  margin: 0;
  color: #fde68a;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-align: center;
}

.league-notice-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.league-notice-sleeve {
  width: 48px;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 4px;
}

.league-notice-mat {
  width: 112px;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 4px;
}

.league-notice-hint {
  margin: 0;
  color: #e5e7eb;
  font-size: 13px;
}

@keyframes noticeRise {
  from { transform: translateY(8px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .league-notice {
    animation: none;
  }
}
</style>
